import { Image, Platform, Text } from 'react-native';
import { ThemedText, ThemedView } from '../../theme'
import { TRANSACTION_SCREEN } from './Transactions'

const ZeroState = ({isLMSUser=false}) => {
    return (
        <ThemedView
            mt='5xl'
            justifyContent='center'
            alignItems='center'
            backgroundColor='bg-surface-primary'
            mx='5xl'
            >
            <Image
                source={{ uri: TRANSACTION_SCREEN }}
                style={{
                    height: Platform.OS !== 'web' ? 250 : 200,
                    width: Platform.OS !== 'web' ? '100%' : 200,
                }}
                resizeMode={'contain'}
            />
            <ThemedText variant='b2s' color='text-secondary' textAlign='center'>
                {isLMSUser?
                    'No transactions to show':
                    'Your transactions will show up here after you start your credit line'
                }
            </ThemedText>
        </ThemedView>
    )
}

export default ZeroState